// 各个区域手机号验证正则
export const localReg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
export const hongkongReg = /^([6|9])\d{7}$/;
export const macaoReg = /^[6]\d{7}$/;
export const taiwanReg = /^[0][9]\d{8}$/;
export const phoneReg = /^(086)?(1[3-9]\d{9})$|^(852)?([69]\d{7})$|^(853)?(6\d{7})$|^(886)?(09\d{8})$/;
function trimExtraChar(value, char, regExp) {
  const index = value.indexOf(char);

  if (index === -1) {
    return value;
  }

  if (char === '-' && index !== 0) {
    return value.slice(0, index);
  }

  return value.slice(0, index + 1) + value.slice(index).replace(regExp, '');
}
export function formatNumber(
  value,
  allowDot = true,
  allowMinus = true
) {
  if (allowDot) {
    value = trimExtraChar(value, '.', /\./g);
  } else {
    value = value.split('.')[0];
  }

  if (allowMinus) {
    value = trimExtraChar(value, '-', /-/g);
  } else {
    value = value.replace(/-/, '');
  }

  const regExp = allowDot ? /[^-0-9.]/g : /[^-0-9]/g;

  return value.replace(regExp, '');
}

export function checkPhoneArea(phone, area) {
  if (!phone || !area) return false;
  switch (area) {
    case "86":
      return localReg.test(phone);
    case "852":
      return hongkongReg.test(phone);
    case "853":
      return macaoReg.test(phone);
    case "886":
      return taiwanReg.test(phone);
    default:
      return false;
  }
}



// WEBPACK FOOTER //
// ./src/js/utils/index.js